<template>
    <div>
        <connect-wallet class="d-none d-md-block" :buttonText=connectButtonText @connectWallet=connect v-if="!walletConnected"></connect-wallet>
        <connect-wallet-mobile class="d-block d-md-none" :buttonText=connectButtonText @connectWallet=connect v-if="!walletConnected"></connect-wallet-mobile>
        <farm-page-connected-wallet @openToast="openToast" @eggsBalance="eggsBalance" v-if="walletConnected"></farm-page-connected-wallet>
    </div>
</template>
<script>
import ConnectWallet from '../components/ConnectWallet.vue'
import ConnectWalletMobile from '../components/ConnectWalletMobile.vue'
import FarmPageConnectedWallet from '../components/FarmPageConnectedWallet.vue'

export default {
    name: 'farm',
    props: {
        mobile: {
            default: false,
            type: Boolean
        },
        walletConnected:{
            default: false,
            type: Boolean
        },
        connectButtonText:{
            default:'Connect Wallet',
            type: String
        }
    },
    components:{
        ConnectWallet,
        ConnectWalletMobile,
        FarmPageConnectedWallet
    },
    data(){
        return {
        }
    },
    mounted(){
    },
    methods:{
        openToast({variant , message}){
            this.$emit('openToast' , {variant: variant , message: message})
        },
        connect(){
            this.$emit('connect' , true)
        },
        eggsBalance(value){
            this.$emit('eggsBalance' , value)
        }
    }
}
</script>